import { lazy } from 'react';

export const designs = [
  { id: 0, name: 'Original (Default)', component: lazy(() => import('./DesignOriginal')) },
  { id: 1, name: 'Classic Elegant', component: lazy(() => import('./Design1')) },
  { id: 2, name: 'Bold Orange', component: lazy(() => import('./Design2')) },
  { id: 3, name: 'Minimal Dark', component: lazy(() => import('./Design3')) },
  { id: 4, name: 'Split Screen', component: lazy(() => import('./Design4')) },
  { id: 5, name: 'Gradient Flow', component: lazy(() => import('./Design5')) },
  { id: 6, name: 'Navy Luxury', component: lazy(() => import('./Design6')) },
  { id: 7, name: 'Editorial', component: lazy(() => import('./Design7')) },
  { id: 8, name: 'Cards Grid', component: lazy(() => import('./Design8')) },
  { id: 9, name: 'Creative Scroll', component: lazy(() => import('./Design9')) },
  { id: 10, name: 'Asymmetric', component: lazy(() => import('./Design10')) },
  { id: 11, name: 'Brutalist', component: lazy(() => import('./Design11')) },
  { id: 12, name: 'Soft Pastel', component: lazy(() => import('./Design12')) },
  { id: 13, name: 'Tech Startup', component: lazy(() => import('./Design13')) },
  { id: 14, name: 'Nature Focus', component: lazy(() => import('./Design14')) },
  { id: 15, name: 'Geometric', component: lazy(() => import('./Design15')) },
  { id: 16, name: 'Cinematic', component: lazy(() => import('./Design16')) },
  { id: 17, name: 'Retro Modern', component: lazy(() => import('./Design17')) },
  { id: 18, name: 'Glassmorphism', component: lazy(() => import('./Design18')) },
  { id: 19, name: 'Bento Grid', component: lazy(() => import('./Design19')) },
  { id: 20, name: 'Monochrome', component: lazy(() => import('./Design20')) },
  { id: 21, name: 'Turkish Heritage', component: lazy(() => import('./Design21')) },
  { id: 22, name: 'Scientific', component: lazy(() => import('./Design22')) },
  { id: 23, name: 'Playful', component: lazy(() => import('./Design23')) },
  { id: 24, name: 'Magazine', component: lazy(() => import('./Design24')) },
  { id: 25, name: 'Premium Luxury', component: lazy(() => import('./Design25')) },
];

